import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsMap from "highcharts/modules/map";
import mapDataWorld from "@highcharts/map-collection/custom/world.geo.json";
import HighChart from "./HighChart";
import { getCountryCoordinates } from "../../utility/utility";
import Skeleton from "react-loading-skeleton";

// Initialize the map module
HighchartsMap(Highcharts);

interface MapFeature {
  properties: {
    name: string;
    "hc-key": string;
  };
}

interface CountryData {
  province: string | null;
  count: number;
}

interface WorldMapData {
  geoStats: {
    number_of_account_per_country: {
      [country: string]: string;
    },
    number_of_account_per_country_province: {
      [country: string]: CountryData;
    };
  };
}

interface MapDataItem {
  name: string;
  lat: number | null;
  lon: number | null;
  country: string;
  z: number | null;
  province: string | null;
}

interface CountriesData {
  [key: string]: string;
}

const WorldMapChart: React.FC<WorldMapData> = (props) => {
  const [countriesData, setCountriesData] = useState<CountriesData>(props?.geoStats?.number_of_account_per_country || null);

  const mapData: MapDataItem[] = mapDataWorld.features.map(
    (feature: MapFeature) => {
      const countryName = feature.properties.name;
      console.log(props?.geoStats?.number_of_account_per_country_province)
      const count =
        props?.geoStats?.number_of_account_per_country_province?.[countryName]
          ?.count || 0;
      if (count === 0) {
        return {name: "", lat: null, lon: null, country: "", z: null, province: null}
      }
      let value = parseInt(count.toString(), 10);
      const coordinates = getCountryCoordinates(countryName);

      return {
        name: countryName,
        lat: coordinates?.latitude || null,
        lon: coordinates?.longitude || null,
        country: "",
        z: value,
        province:
          props?.geoStats?.number_of_account_per_country_province?.[countryName]
            ?.province || null,
      };
    }
  );

  const chartOptions = {
    chart: {
      map: mapDataWorld,
    },
    title: {
      text: "",
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: "bottom",
      },
    },
    colorAxis: {
      min: 0,
      stops: [
        [0, "#EFEFFF"],
        [1, "#9930DC"],
      ],
    },
    credits: {
      enabled: false, // Disable credits
    },
    legend: {
      enabled: false, // Disable legend
    },
    series: [
      {
        type: "map",
        data: mapData,
        mapData: mapDataWorld,
        name: "Basemap",
        borderColor: "#A0A0A0",
        color: "#BADA55",
        states: {
          hover: {
            brightness: 0.1,
            borderColor: "#000000",
            borderWidth: 2,
          },
          inactive: {
            opacity: 1,
          },
        },
      },
      {
        type: "mapbubble",
        name: "Country",
        data: mapData,
        joinBy: null,
        minSize: 4,
        maxSize: "2%",
        tooltip: {
          formatter: function (this: any) {
            return this.point.z > 0
              ? `${this.point.name}: ${this.point.z}`
              : "";
          },
        },
        states: {
          hover: {
            brightness: 0.1,
            borderColor: "#000000",
            borderWidth: 2,
          },
          inactive: {
            opacity: 1,
          },
        },
      },
    ],
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: true,
            brightness: 0.1,
            borderColor: "#000000",
            borderWidth: 2,
            color: "#BADA55",
          },
          inactive: {
            opacity: 1,
          },
        },
      },
      mapbubble: {
        states: {
          hover: {
            enabled: true,
            brightness: 0.1,
            borderColor: "#000000",
            borderWidth: 2,
            color: "#BADA55",
          },
          inactive: {
            opacity: 1,
          },
        },
      },
    },
  };

  return (
    <React.Fragment>
      {props?.geoStats ? (
        <>
          <div className="map-section">
            <HighChart options={chartOptions} constructorType={"mapChart"} />
          </div>
          <div className="world-map-data">
            <ul>
              {countriesData &&
                Object.entries(countriesData).map(([key, value]) => (
                  <li key={key}>
                    <p>{key}</p>
                    <span>{value}</span>
                  </li>
                ))}
            </ul>
          </div>
        </>
      ) : (
        <Skeleton count={14} />
      )}
    </React.Fragment>
  );
};

export default WorldMapChart;
